import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { AuthProvider } from "./contexts/AuthContext";
import { LeaveProvider } from "./contexts/LeaveContext";
import { ToastProvider } from "./contexts/ToastContext";
import AppRoutes from "./routes/AppRoutes";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0f52ba",
      light: "#eff6ff",
      dark: "#1d4ed8",
    },
    secondary: {
      main: "#10b981",
      light: "#ecfdf5",
      dark: "#059669",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <LeaveProvider>
            <ToastProvider>
              <AppRoutes />
            </ToastProvider>
          </LeaveProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;